import {Box} from '@mui/material';

import {WorkforceProfileAlignmentItemCard} from './WorkforceProfileAlignmentItemCard';
import {WorkforceProfileCompetencyRow} from '../../types/WorkforceProfileTypes';
import {getAlignmentRowKey} from '../../utils/WorkforceProfileDetail/workforceAlignmentOverviewUtils';
import {getEvolutionSkillKeyFromRow} from '../../utils/WorkforceProfileDetail/workforceVersionEvolutionUtils';

export interface Props {
  rows: WorkforceProfileCompetencyRow[];
  met: boolean;
  language: 'en' | 'de';
  newlyMetKeys?: Set<string>;
  newlyMetNote?: string;
}

export const WorkforceProfileAlignmentItemsGrid = ({
  rows,
  met,
  language,
  newlyMetKeys,
  newlyMetNote,
}: Props) => {
  if (rows.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: 1,
      }}
    >
      {rows.map((row) => {
        const isNewlyMet =
          met &&
          !!newlyMetKeys?.has(getEvolutionSkillKeyFromRow(row));

        return (
          <WorkforceProfileAlignmentItemCard
            key={getAlignmentRowKey(row)}
            row={row}
            met={met}
            language={language}
            isNewlyMet={isNewlyMet}
            newlyMetNote={isNewlyMet ? newlyMetNote : undefined}
          />
        );
      })}
    </Box>
  );
};
